import { decryptData } from "utils";

const configObj = {
  dev: {
    mirror: {
      API_URL: "http://192.168.4.49:8080/api/v1",
      API_URL_V2: "http://192.168.4.49:8080/api/v2",
      DAV_URL: "http://192.168.4.112:8080/",
      VIRT_URL: "http://192.168.4.98:8000/api/v1/",
      reCapcha: {
        V: "6LeT1rAZAAAAAHEZX0LFWSuY0jzcWNbBGVc2hS0t",
        IV: "6LeT1rAZAAAAAHEZX0LFWSuY0jzcWNbBGVc2hS0t"
      },
      APP_INSTANCE: "mirror"
    },
    ibackup: {
      API_URL: "http://192.168.8.252:8080/api/v1",
      API_URL_V2: "http://192.168.8.252:8080/api/v2",
      DAV_URL: "http://192.168.1.189:8080/",
      VIRT_URL: "http://192.168.4.98:8000/api/v1/",
      reCapcha: {
        V: "6LeT1rAZAAAAAHEZX0LFWSuY0jzcWNbBGVc2hS0t",
        IV: "6LeT1rAZAAAAAHEZX0LFWSuY0jzcWNbBGVc2hS0t"
      },
      APP_INSTANCE: "ibackup"
    }
  },
  prod: {
    mirror: {
      API_URL: "https://api.idrivemirror.com/api/v1",
      API_URL_V2: "https://api.idrivemirror.com/api/v2",
      DAV_URL: "https://user.idrivemirror.com/",
      VIRT_URL: "https://api-hyperv.idrivemirror.com/api/v1/",
      reCapcha: {
        V: "6LeaOeEZAAAAAOJNpo_lD-KBH_c6YpM0NresG70B",
        IV: "6LeaOeEZAAAAAOJNpo_lD-KBH_c6YpM0NresG70B"
      },
      APP_INSTANCE: "mirror"
    },
    ibackup: {
      API_URL: "https://apimirror.ibackup.com/api/v1",
      API_URL_V2: "https://api.idrivemirror.com/api/v2",
      DAV_URL: "https://user.idrivemirror.com/",
      VIRT_URL: "https://api-hyperv.idrivemirror.com/api/v1/",
      reCapcha: {
        V: "6LeaOeEZAAAAAOJNpo_lD-KBH_c6YpM0NresG70B",
        IV: "6LeaOeEZAAAAAOJNpo_lD-KBH_c6YpM0NresG70B"
      },
      APP_INSTANCE: "ibackup"
    }
  }
};

export const config =
  configObj[process.env.REACT_APP_ENV.trim()][
    process.env.REACT_APP_NAME.trim()
  ];

export function reConfig() {
  config.WS_URL =
    (process.env.REACT_APP_ENV.trim() === "prod" ? "wss://" : "ws://") +
    JSON.parse(decryptData(localStorage.getItem("serverDetails"))).pnsServerIp +
    (process.env.REACT_APP_ENV.trim() === "prod" ? "" : "") +
    "/IDriveMirrorPNS/websocketendpoint";
}

export function configAppInstance(app) {
  if (app === "ibackup") {
    config.APP_INSTANCE = "ibackup";
  } else {
    config.APP_INSTANCE = "mirror";
  }
}
